<template>
  <div class="flex flex-1 flex-col items-center max-w-md overflow-auto">
    <div class="flex flex-row flex-wrap px-4">
      <c-option
        class="my-5 ml-6 w-2/5"
        v-for="lang in languages"
        :option="lang"
        :key="lang.value"
        :selected="language && language.value === lang.value"
        @checked="onCheck"
      />
    </div>
    <c-button class="mt-auto ok-button" @click="ok">
      <span>{{ $t('homePage.ok') }}</span>
    </c-button>
  </div>
</template>

<script>
import COption from '@/components/common/COption.vue';
import CButton from '@/components/common/CButton.vue';

export default {
  name: 'Language',
  components: {
    CButton,
    COption,
  },
  mounted() {
    const { locale } = this.$root.$i18n;
    this.language = this.languages.find(l => l.value === locale) || {};
  },
  data: () => ({
    language: {},
    languages: [
      { name: 'English', value: 'en' },
      { name: 'Español', value: 'es' },
      { name: '日本語', value: 'ja' },
      { name: 'Deutsch', value: 'de' },
      { name: '简体中文', value: 'zh-cn' },
      { name: '繁體中文', value: 'zh-tw' },
      { name: 'Français', value: 'fr' },
      { name: '한국어', value: 'ko' },
      { name: 'Türkçe', value: 'tr' },
      { name: 'Tiếng Việt', value: 'vi' },
      { name: 'Italiano', value: 'it' },
      { name: 'Português', value: 'pt' },
      { name: 'Română', value: 'ro' },
    ],
  }),
  methods: {
    ok() {
      this.$emit('set-locale', this.language);
    },
    onCheck(item) {
      this.language = item;
    },
  },
};
</script>

<style scoped>
.ok-button {
  margin-bottom: calc(2rem + env(safe-area-inset-bottom));
}
</style>
